import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ButtonGroup, ToggleButton } from 'react-bootstrap';
import Select from 'react-select';

/**
 * Componente para seleccionar si es una orden de distribuidor
 * y en caso afirmativo, seleccionar el distribuidor
 */
const SelectorDistribuidor = ({ 
    esDistribuidor, 
    onCambiarTipo, 
    distribuidores, 
    distribuidorSeleccionado,
    onSeleccionarDistribuidor
}) => {
    return (
        <>
            <Row>
                <Col md={12} className="mb-md-0">
                    <div className="d-flex mb-0 align-items-center">
                        <ButtonGroup>
                            <ToggleButton
                                type="radio"
                                id="rd_distribuidor_si"
                                variant="outline-success"
                                name="radioDistribuidor"
                                value={true}
                                checked={esDistribuidor === true}
                                size="sm"
                                onChange={() => onCambiarTipo(true)}
                            >
                                SI
                            </ToggleButton>
                            <ToggleButton
                                type="radio"
                                id="rd_distribuidor_no"
                                variant="outline-danger"
                                name="radioDistribuidor"
                                value={false}
                                checked={esDistribuidor === false}
                                size="sm"
                                onChange={() => onCambiarTipo(false)}
                            >
                                NO
                            </ToggleButton>
                        </ButtonGroup>
                        <span className="mb-1 ms-1 fw-bold">DISTRIBUIDOR</span>
                    </div>
                    <hr className="mt-0" />
                </Col>
            </Row>
            {esDistribuidor === true && (
                <Row>
                    <Col md={12} className="mb-3 mb-md-0">
                        <Select
                            className="basic-single"
                            closeMenuOnSelect={true}
                            options={distribuidores}
                            isSearchable={true}
                            placeholder="Selecciona..."
                            classNamePrefix="react-select"
                            onChange={onSeleccionarDistribuidor}
                            value={distribuidores.find(d => d.value === distribuidorSeleccionado)}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

SelectorDistribuidor.propTypes = {
    esDistribuidor: PropTypes.bool,
    onCambiarTipo: PropTypes.func.isRequired,
    distribuidores: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        vRazonSocial: PropTypes.string,
        vRfc: PropTypes.string,
        vNumRegTrib: PropTypes.string,
        idCatUsoCFDI: PropTypes.number,
        idCatRegimenFiscal: PropTypes.number,
        vCp: PropTypes.string,
        vDireccionFiscal: PropTypes.string,
        vEstadoDepProv: PropTypes.string,
        vPais: PropTypes.string,
        vEmailFacturacion: PropTypes.string,
        vTelefonoFacturacion: PropTypes.string,
        vCodigoUso: PropTypes.string,
        vDescripcionUsoCFDI: PropTypes.string,
        vCodigoRegimen: PropTypes.string,
        vDescripcionRegimenFiscal: PropTypes.string
    })).isRequired,
    distribuidorSeleccionado: PropTypes.number,
    onSeleccionarDistribuidor: PropTypes.func.isRequired
};

export default SelectorDistribuidor;
